import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field } from "formik";
import { styled } from "../../theme";
import { Multiselect } from "../../multiselect";
import { FloatingFieldLabel } from "../atoms/FloatingFieldLabel";
import { FieldBorder } from "../atoms/FieldBorder";
import { FieldError } from "../atoms/field-error";
import { isInvalid } from "../formHelpers";
/**
 * A formik field for selecting multiple tags.
 *
 * @param {TagsFieldProps} props The props for the component.
 * @returns {JSX.Element} The rendered tags field component.
 */
export const TagsField = ({ name, label, disabled, options, placeholder, maxSelected, testId, }) => (_jsx(Field, { name: name, children: ({ form, field }) => (_jsxs(LabelWrapper, { children: [_jsx(FloatingFieldLabel, { visible: true, children: label }), _jsx(AlignCenter, { children: _jsx(Multiselect, { name: name, testId: testId, options: options, placeholder: placeholder, selected: disabled ? options.map(o => o.value) : field.value, disabled: disabled, maxSelected: maxSelected, onChange: values => form.setFieldValue(field.name, values, true) }) }), _jsx(FieldBorder, { invalid: isInvalid(name, form) }), _jsx(FieldError, { name: name })] })) }));
const LabelWrapper = styled.label `
  width: 100%;
  display: inline-block;
  padding: 6px 0;
  margin: 8px 0;
`;
const AlignCenter = styled.div `
  display: flex;
  align-items: center;
`;
